import cycleStates from "@/utils/states/cycle";

const STATES = {
  active: {
    order: 0,
    icon: "/static/icon_order_status_ok.svg",
    name: "ativa",
    color: "success"
  },
  accepted: {
    order: 1,
    icon: "/static/icon_order_status_ok.svg",
    name: "aceita",
    color: "success"
  },
  requested: {
    order: 2,
    icon: "/static/icon_order_status_alert.svg",
    name: "solicitada",
    color: "warning"
  },
  created: {
    order: 3,
    icon: "/static/icon_order_status_alert.svg",
    name: "criada",
    color: "primary"
  },
  paused: {
    order: 4,
    icon: "/static/icon_order_status_canceled.svg",
    name: "pausada",
    color: "disabled"
  },
  rejected: {
    order: 5,
    icon: "/static/icon_order_status_canceled.svg",
    name: "reijeitada",
    color: "disabled"
  },
  cancelled: {
    order: 6,
    icon: "/static/icon_order_status_canceled.svg",
    name: "cancelada",
    color: "disabled"
  }
};

function getState(state) {
  return STATES[state] || null;
}

function getOrderState(state) {
  return STATES[state].order || 0;
}

function sortByState(subscriptions) {
  return subscriptions.sort((a, b) => {
    return getOrderState(a.status) - getOrderState(b.status);
  });
}

function filterCycles(subscriptions) {
  let hiddenStates = ["created"];
  subscriptions.forEach(
    s => (s.cycles = cycleStates.filterCycles(s.cycles, "status", hiddenStates))
  );
  return subscriptions;
}

function sortCycles(subscriptions) {
  subscriptions.forEach(s => (s.cycles = cycleStates.sortByStartsAt(s.cycles)));
  return subscriptions;
}

export default {
  getState,
  sortByState,
  filterCycles,
  sortCycles
};



// WEBPACK FOOTER //
// ./src/utils/states/subscription.js